const module = {
  moduleType: 'Welcome',
  moduleId: 'welcome',
  api: 'welcome',
};
export default module;
